exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.oc-table-cell-input.form-group[data-v-2995ff27] {\r\n    margin-bottom: 0;\n}\n.oc-table-cell-input.form-group[data-v-2995ff27] .input-group {\r\n    flex-direction: column;\n}\n.oc-table-cell-input.form-group[data-v-2995ff27] .input-group .form-control {\r\n    width: 100%;\n}\r\n", ""]);

